import { createFileRoute } from '@tanstack/react-router'

import { requireAuthentication } from '@/utils/router/redirects'
import { ChatView } from '@/views/chat/ChatView'

export const Route = createFileRoute('/')({
  component: ChatView,
  beforeLoad: async () => {
    await requireAuthentication()
  },
})
